import { useEffect } from "react";
import PublicLayout from "@/components/PublicLayout";

const WHATSAPP_GROUP = "https://chat.whatsapp.com/FTpF0TyZG2nJkWpWKPdlrM?mode=hqrc";

export default function ContactPage() {
  useEffect(() => { document.title = "Contact Us | The Better Fare"; }, []);

  return (
    <PublicLayout>
      {/* Page Banner */}
      <div
  data-testid="page-title"
  style={{
    background: "linear-gradient(135deg, #6C3084, #4a1f6e)",
    padding: "60px 20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  <h1
    style={{
      fontFamily: "'Poppins', sans-serif",
      fontSize: "2.5rem",
      fontWeight: 700,
      color: "#fff",
      margin: 0,
      textAlign: "center",
    }}
  >
    Get in Touch
  </h1>

  <p
    style={{
      fontFamily: "'Poppins', sans-serif",
      fontSize: "1rem",
      color: "rgba(255,255,255,0.72)",
      marginTop: "10px",
      marginBottom: 0,
      textAlign: "center",
    }}
  >
    We'd love to hear from you.
  </p>
</div>

      <div className="max-w-5xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <p className="text-gray-600 leading-relaxed max-w-2xl mx-auto" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Have questions or need assistance? Reach out to us through any of the channels below and our team will get back to you as soon as possible.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-gray-50 rounded-xl p-8 border border-gray-100 text-center">
            <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6C3084" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            </div>
            <h3 style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: "1.1rem", color: "#1a1a1a", marginBottom: "8px" }}>Email</h3>
            <a href="mailto:info@thebetterfare.com" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.9rem", color: "#6C3084", textDecoration: "none" }}>info@thebetterfare.com</a>
          </div>

          <div className="bg-gray-50 rounded-xl p-8 border border-gray-100 text-center">
            <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6C3084" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            </div>
            <h3 style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: "1.1rem", color: "#1a1a1a", marginBottom: "8px" }}>Location</h3>
            <p style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.9rem", color: "#666", textAlign: "center" }}>Arnhem, The Netherlands</p>
                      </div>

          <div className="bg-gray-50 rounded-xl p-8 border border-gray-100 text-center">
            <div className="w-14 h-14 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6C3084" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            </div>
            <h3 style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: "1.1rem", color: "#1a1a1a", marginBottom: "8px" }}>Social Media</h3>
            <div className="flex items-center justify-center gap-4 mt-2">
              <a href="https://www.facebook.com/TheBetterFare/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#6C3084] transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"/></svg>
              </a>
              <a href="https://x.com/TheBetterFare" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#6C3084] transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.instagram.com/thebetterfare/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#6C3084] transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153.509.5.902 1.105 1.153 1.772.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 01-1.153 1.772c-.5.508-1.105.902-1.772 1.153-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 01-1.772-1.153 4.904 4.904 0 01-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 011.153-1.772A4.897 4.897 0 015.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 1.802c-2.67 0-2.986.01-4.04.059-.976.045-1.505.207-1.858.344-.466.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.048 1.055-.058 1.37-.058 4.041 0 2.67.01 2.986.058 4.04.045.977.207 1.505.344 1.858.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058 2.67 0 2.987-.01 4.04-.058.977-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041 0-2.67-.01-2.986-.058-4.04-.045-.977-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.055-.048-1.37-.058-4.041-.058zm0 3.063a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 8.468a3.333 3.333 0 100-6.666 3.333 3.333 0 000 6.666zm6.538-8.671a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"/></svg>
              </a>
            </div>
          </div>
        </div>

        {/* WhatsApp CTA */}
        <div className="text-center">
          <p className="text-gray-600 mb-6" style={{ fontFamily: "'Poppins', sans-serif", fontSize: "1rem" }}>
            The fastest way to reach us is via WhatsApp — join our group and we'll get back to you quickly.
          </p>
          <a
            href={WHATSAPP_GROUP}
            target="_blank"
            rel="noopener noreferrer"
            className="tbf-whatsapp-btn"
          >
            The Better Fare | WhatsApp Group
          </a>
        </div>
      </div>
    </PublicLayout>
  );
}
